import { render, staticRenderFns } from "./DoctorDetails.vue?vue&type=template&id=723aa572"
import script from "./DoctorDetails.vue?vue&type=script&lang=js"
export * from "./DoctorDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports